import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";


import UserService from "../services/user.service";


const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};


const users = {data: list, loading: false};


export const updateUser = createAsyncThunk(
  "auth/updateUser",
  async ( {user},thunkAPI) => {
    try {
      const data = await UserService.updateUser(user);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);



export const getUsers = createAsyncThunk(
  "auth/get_users",
  async ({search}, thunkAPI) => {
    try {

      const data = await UserService.getUsers(search);
      return { users: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getUser = createAsyncThunk(
  "auth/get_user",
  async ({username}, thunkAPI) => {
    try {
      const data = await UserService.getUser(username);
      return { users: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);



const initialState = { users}

const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: {

    [getUsers.pending]: (state, action) => {
      state.users.loading = true;
    },
    [getUsers.fulfilled]: (state, action) => {
      state.users.data = action.payload.users; 
      state.users.loading = false;
    },
    [getUsers.rejected]: (state, action) => {
      state.users.data = list
      state.users.loading = false;
    },

    [updateUser.fulfilled]: (state, action) => {

      debugger
      
      let users = state.users.data.list;
      let thisUser = users.find((user) => user.username === action.payload.data.username)

      thisUser.firstName = action.payload.data.firstName
      thisUser.lastName = action.payload.data.lastName
      thisUser.email = action.payload.data.email
      thisUser.note = action.payload.data.note
      thisUser.avatar = action.payload.data.avatar
      thisUser.active = action.payload.data.active

    },

    [getUser.pending]: (state, action) => {
      state.users.loading = true;
    },
    [getUser.fulfilled]: (state, action) => {

      state.users.data.list.push(action.payload.users.user)
      state.users.data.total ++;

      state.users.loading = false;
    },
    [getUser.rejected]: (state, action) => {
      state.users.loading = false;
    },


  },
});


const { reducer } = userSlice;
export default reducer;